The upper limit of advertisement products to return in the list.

If your user interface can only display a certain number of products,
set this limit so that SEEK can provide the most relevant set of products within your constraints.
Do not manually truncate the returned list as that may exclude highly relevant products.

This must be a positive integer that is greater than or equal to 4.
Defaults to a unbounded list though expect this to remain within reason;
we typically return up to 3 products and have only discussed an increase to 4 in future.
